import React from "react";
import "react-data-table-component-extensions/dist/index.css";
import { GroupDetailsTable } from "../allTables/allTable";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import GroupService from "../../services/group.service";
import { Card, Col, Button } from "react-bootstrap";
import useDialogState from "../../hooks/useDialog";
import { AddMember } from "../modals/allModal";
import { useFormik } from "formik";
import * as yup from "yup";
import UserService from "../../services/user.service";
import { useSnackbar } from "notistack";
import { CSVLink } from "react-csv";

const schema = yup.object().shape({
  memberName: yup.string().required("Please select member from list!"),
});

export function GroupDetails() {
  const location = useLocation();
  const [data, setData] = useState("");
  const [allData, setAllData] = useState([]);
  const [totalRows, setTotalRows] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [totalGroups, setTotalGroups] = useState();
  const [userData, setUserData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");

  const groupId = location?.state?.id;
  const searchParams = new URLSearchParams(location.search);
  const groupName = decodeURIComponent(searchParams.get("groupName"));
  const { enqueueSnackbar } = useSnackbar();

  const initialValue = {
    id: "",
    memberName: "",
  };

  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const getGroupDetails = async () => {
    try {
      setIsLoading(true)
      const response = await GroupService.getGroupMembers(
        groupId,
        search,
        pageNumber,
        dataPerPage
      );
      setData(response.data.data);
      setTotalRows(response.data.total);
      setTotalGroups(response.data.total);
    } catch (error) {
      console.error("Not able to get groupmembers", error);
    } finally{
      setIsLoading(false)
    }
  };

  const getAllGroupMembersDetails = async () => {
    try {
      const response = await GroupService.getGroupMembers(groupId, "", "");
      setAllData(response.data.data);
    } catch (error) {
      console.error("Not able to get groupmembers", error);
    }
  };

  const getAllUserData = async () => {
    const response = await UserService.getAllUserList();
    setUserData(response.data.data);
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getGroupDetails();
    if (!search) {
      getAllUserData();
      getAllGroupMembersDetails();
    }
  }, [pageNumber, dataPerPage, search]);

  const memberName = userData.map((user) => ({
    value: user.userName,
    label: user.userName,
    id: user._id,
  }));

  const openAddMemberModel = async () => {
    handleDialogOpen();
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      const response = await GroupService.addNewMemberInGroup(
        groupId,
        values.id
      );
      setLoader(false);
      handleDialogClose();
      getGroupDetails();
      action.resetForm();
      enqueueSnackbar(
        `${
          response.data.message === "Group join successfully"
            ? response.data.message
            : "This user is already member of this group!"
        }`,
        {
          variant:
            response.data.message === "Group join successfully"
              ? "success"
              : "error",
        }
      );
    } catch (error) {
      console.error("create race error", error);
      enqueueSnackbar(`Something went wrong! :${error.response.data.message}`, {
        variant: "error",
      });
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const headers = [
    { label: "Unique Code", key: "useUniqueCode" },
    { label: "User Name", key: "userName" },
    { label: "Member Name", key: "fullName" },
    { label: "Country", key: "countryName" },
  ];

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Group Members
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-users icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalGroups}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={6} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            {/* {allData?.length > 0 && ( */}
              <CSVLink
                data={
                  allData?.length > 0
                    ? allData?.map((item) => ({
                        ...item,
                      }))
                    : []
                }
                headers={headers}
                filename={`${groupName}_group_members.csv`}>
                <Button
                  className="text-white"
                  disabled={isLoading || allData?.length === 0}
                  style={{ marginBottom: "5px", marginLeft: "15px" }}>
                  <i className="fas fa-download"></i> &nbsp; Export Members
                </Button>
              </CSVLink>
            {/* )} */}
            <Button
              className="text-white"
              onClick={() => openAddMemberModel("")}
              style={{ marginBottom: "5px", marginLeft: "15px" }}>
              <i className="fas fa-plus"></i> &nbsp; Add Member
            </Button>
          </div>
        </Col>
      </div>
      <GroupDetailsTable
        data={data}
        groupName={groupName}
        getGroupMembers={getGroupDetails}
        handleData={(e) => setSearch(e.target.value)}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        dataPerPage={dataPerPage}
        isLoading={isLoading}
        groupId={groupId}
        setDataPerPage={setDataPerPage}
      />
      {modalShows && (
        <AddMember
          loader={loader}
          show={handleDialogOpen}
          onHide={handleDialogClose}
          formik={formik}
          userData={memberName}
          update={false}
        />
      )}
    </>
  );
}
